import Select from "react-select";
import React, { useEffect, useState, useRef } from "react";
import { useParams, useLocation } from 'react-router-dom';
import Form from 'react-bootstrap/Form';
import { useDispatch, useSelector } from "react-redux";
import { getAsset } from "../../actions/assetAction";
import { useNavigate } from "react-router";
import { DatePicker } from "@progress/kendo-react-dateinputs";
import { SBADropDown, SBAMultiSelect } from "../../UiComponents/SBADropDown";
import { getShareClassFeedetails, getShareClassdetails } from "../../actions/assetShareClassAction";
import { sbaAxios } from '../../utils/sbaAxios';
import { TopBar } from "../../shared/topBar/TopBar";
import { LoadingScreen } from '../../UiComponents/LoadingComponent';
import { UrlPath } from "../../../config/routeConfig";
import { BreadCrumbs } from "../../shared/breadCrumbs/BreadCrumbs";
import { ToastContainer, toast } from 'react-toastify';
import { getDDvalues } from "../../CommonAPI";
import { baseURL } from "../../../config/apiConfig";
import { InsertorUpdateShareClass, getDDListValues } from "../../../config/apiConfig";
import moment from "moment";
import { SBDatePicker } from "../../UiComponents/SBDatePicker";

export const ShareClassEdit = () => {
  
 const isEditable=useSelector(state=>state.authorizationData.isEditable);
    const params = useParams();
    const location = useLocation();
    const dispatch = useDispatch();
    const history = useNavigate();
    const AssetID = parseInt(params.Asset);
    const ShareClassId = parseInt(params.ShareClassID);
    const Gstate = useSelector(state => { return state; }) || {};
    const currentAsset = Gstate.asset.asset || {};

    const [ddValuesForShareClass, setDDValuesForShareClass] = useState();
    const [loading, setLoading] = useState(true);
    const ShareClassAtrriburtes = useSelector(state => state.shareClassData.shareClassData[0]) || [];
    const ShareClassFee = useSelector(state => state.shareClassFeeData.shareClassFeeData[0]) || [];
    //useState for Share Class fee
    const [isDefault,setIsDefault]=useState();
    const [shareClass, setShareClass] = useState();
    const [minInvestment, setMinInvestment] = useState();
    const [inceptionDate, setInceptionDate] = useState(new Date);
    const [effectiveDate, setEffectiveDate] = useState(new Date);
    const [investmentCurrency, setInvestmentCurrency] = useState([]);
    const [subscriptionFrequency, setSubscriptionFrequency] = useState();
    const [taxReporting, setTaxReporting] = useState();
    const [votingShares, setVotingShares] = useState(false);
    const [newIssues, setNewIssues] = useState(false);
    const [accredited, setAccredited] = useState(false);
    const [qualifiedPurchaser, setQualifiedPurchaser] = useState(false);
    const [qualifiedClient, setQualifiedClient] = useState(false);
    const [trackingFrequency, setTrackingFrequency] = useState();
    const [trackedBy, setTrackedBy] = useState();
    const [initialNAV, setInitialNAV] = useState();
    const [businessDays, setBusinessDays] = useState(false);
    const [liquidityTerms,setLiquidityTerms]=useState();

    //useState for Share Class fee
    
    const [managementFee, setManagementFee] = useState();
    const [mngFeeFrequency, setMngFeeFrequency] = useState();
    const [performanceFee, setPerformanceFee] = useState();
    const [paymentFrequency, setPaymentFrequency] = useState();
    const [accuralFrequency, setAccuralFrequency] = useState();
    const [hurdleRate, setHurdleRate] = useState();
    const [hurdleValue, setHurdleValue] = useState();
    const [lossRecoverys, setLossRecoverys] = useState();
    const [recoveryReset, setRecoveryReset] = useState();
    useEffect(() => {
        document.title = "Share Class Edit";
        dispatch(getShareClassdetails(ShareClassId));
        dispatch(getShareClassFeedetails(ShareClassId));
        dispatch(getAsset(AssetID));
        getDropDownValues();
    }, []);



    const getDropDownValues = async () => {
        try {
            const response = await sbaAxios({
                url: `${getDDListValues}`,
                method: 'get',
            })
            const data = response;
            setDDValuesForShareClass(data);
        } catch (error) { console.log(error, 'error fetching dropdown values') };
    }

    //const getDropDownValues = async () => {
    //    try {
    //        const response = await axios.get(getDDListValues);
           
    //        setDDValuesForShareClass(response.data);
    //    } catch (error) {
    //        console.error('Error fetching dropdown values:', error);
    //    }
    //};

 
    useEffect(() => {
        ShareClassAtrriburtes && ddValuesForShareClass && currentAsset && setLoading(false);
        //Setting the default value to the state 
        setIsDefault(ShareClassAtrriburtes.IsDefault);
        setShareClass(ShareClassAtrriburtes.ShareClassName);
        setMinInvestment(ShareClassAtrriburtes.MinInvestment);
        setInceptionDate(new Date(ShareClassAtrriburtes.InceptionDate));
        setEffectiveDate(new Date(ShareClassAtrriburtes.EffectiveDate));
        setInvestmentCurrency(ShareClassAtrriburtes?.SubscriptionCurrencyIdList?.map(item => { return { "Id": item.CurrencyId, "Description": item.CurrencyName } }) || []);
        setSubscriptionFrequency({ Id: ShareClassAtrriburtes.SubscriptionFrequencyId, Description: ShareClassAtrriburtes.SubscriptionFrequencyName });
        setTaxReporting({ Id: ShareClassAtrriburtes.TaxReportingId, Description: ShareClassAtrriburtes.TaxReportingName });
        setVotingShares(ShareClassAtrriburtes.VotingShares);
        setNewIssues(ShareClassAtrriburtes.NewIssues);
        setAccredited(ShareClassAtrriburtes.Accredited);
        setQualifiedPurchaser(ShareClassAtrriburtes.QualifiedPurchaser);
        setQualifiedClient(ShareClassAtrriburtes.QualifiedClient);
        setTrackingFrequency({ Id: ShareClassAtrriburtes.TrackingFrequencyId, Description: ShareClassAtrriburtes.TrackingFrequencyName });
        setTrackedBy({ Id: ShareClassAtrriburtes.TrackingById, Description: ShareClassAtrriburtes.TrackingByName });
        setInitialNAV(ShareClassAtrriburtes.InitialNAV);
        setLiquidityTerms(ShareClassAtrriburtes.LiquidityTermsAbrev);
        setBusinessDays(ShareClassAtrriburtes.BusinessDays);

        setManagementFee(ShareClassFee.MgmtFee);
        setMngFeeFrequency({ Id: ShareClassFee.MgmtFeeFrequencyId, Description: ShareClassFee.MgmtFeeFrequencyName });
        setPerformanceFee(ShareClassFee.PerfFee);
        setPaymentFrequency({ Id: ShareClassFee.PerfFeePaymentFrequencyId, Description: ShareClassFee.PerfFeePaymentFrequencyName });
        setAccuralFrequency({ Id: ShareClassFee.PerfFeeAccrualFrequencyId, Description: ShareClassFee.PerfFeeAccrualFrequencyName });
        setHurdleRate({ Id: ShareClassFee.HurdleRateId, Description: ShareClassFee.HurdleRateName });
        setHurdleValue(ShareClassFee.HurdleValue);
        setLossRecoverys(ShareClassFee.LossRecovery);
        setRecoveryReset({ Id: ShareClassFee.LossRecoveryResetId, Description: ShareClassFee.LostRecoveryResetName });

    }, [ddValuesForShareClass, ShareClassAtrriburtes, ShareClassFee]);

    const Level = [
        { BreadCrumb: "Asset >", Routes: `${UrlPath.Asset}` },
        { BreadCrumb: "Details >", Routes: `${UrlPath.AssetDetails}${params.Asset}` },
        
         { BreadCrumb: "Edit", Routes: `${UrlPath.AssetShareClassEdit}${params.Asset}\\${ShareClassId}` },

    ];
    const InvestmentCryDDChange = (e) => {
        setInvestmentCurrency(value =>
            e.value
        );
    }

    const SubFreDDchange = (e) => {
        setSubscriptionFrequency(e.value);
    }


    const TaxRepChange = (e) => {
        setTaxReporting(e.value);
    }

    const TrackingFreDDChange = (e) => {
        setTrackingFrequency(e.value);
    }

    const TrackedByDDChange = (e) => {
        setTrackedBy(e.value);
    }
    const saveShareClass = () => {
        const investmentCurrencyId = investmentCurrency.map(currency => currency.Id);
        const shareClassfeeData={
            "shareClassId": ShareClassId,
            "mgmtFeeTierId": 0,
            "mgmtFeeTierDesc": null,
            "mgmtFee": managementFee,
            "mgmtFeeFrequencyId": mngFeeFrequency.Id,
            "isMgmtFeeFreqPassThrough": false,
            "perfFeeTierId": 0,
            "perfFeeTierDesc": null,
            "perfFee": performanceFee,
            "perfFeePaymentFrequencyId": paymentFrequency.Id,
            "perfFeeAccrualFrequencyId": accuralFrequency.Id,
            "hurdleRateId": hurdleRate.Id,
            "hurdleValue": hurdleValue,
            "hurdleRateBenchMarkId": 0,
            "lossRecovery": lossRecoverys,
            "lossRecoveryResetId": recoveryReset.Id,
            "modifiedBy": 38
          }
        const shareClassData = {
            shareClassId: ShareClassId,
            shareClassName: shareClass,
            assetId: AssetID,
            portfolioId: null,
            isDefault: isDefault,
            inceptionDate: (inceptionDate).toISOString(),
            effectiveDate: effectiveDate,
            minInvestment: minInvestment,
            subscriptionFrequencyId: subscriptionFrequency.Id,
            subscriptionCurrencyIdList: investmentCurrencyId.join(','),
            taxReportingId: taxReporting.Id,
            votingShares: votingShares,
            newIssues: newIssues,
            trackingFrequencyId: trackingFrequency.Id,
            trackingById: trackedBy.Id,
            accredited: accredited,
            qualifiedPurchaser: qualifiedPurchaser,
            qualifiedClient: qualifiedClient,
            initialNAV: initialNAV,
            businessDays: businessDays,
            modifiedBy: 38,
            liquidityTermsAbrev: liquidityTerms,
            feeDetails:shareClassfeeData
        }
       

        if ((shareClass == null) || (shareClass === '') || (shareClass.trim()).length === 0) {
            toast.error("Kindly Fill  Share class Name", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
                theme: "light",
            })
        }
        else {
                sbaAxios({
                    url:`${InsertorUpdateShareClass}`,
                method: 'post',
                data: shareClassData,
            }).then(() => {
                toast.success("Share Class Updated Successfully", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                })
                setTimeout(() => {
                    history(`${UrlPath.AssetDetails}${params.Asset}`, { state: { ActiveTab: "shareClass", ActiveTabID: 3 ,shareClassId:ShareClassId,shareClassName:shareClass} })
                  }, 1000);
            }).catch(() => {
                toast.error("Error saving Data", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                })
            })
           
           
        }
    }
    const navigateToDetails = () => {
        history(`${UrlPath.AssetDetails}${params.Asset}`, { state: { ActiveTab: "shareClass", ActiveTabID: 3,shareClassId:ShareClassId,shareClassName:shareClass } })
    }
    return (
        <div>
            {loading ? (
                <LoadingScreen />
            ) : <div>
                <TopBar label={"Share Class Edit"} />
                <BreadCrumbs Levels={Level} />
                <div id="shareClassEdit" className="asset-detail-screen p-4 mainContentData">
                    <div className="d-flex align-items-center justify-content-between my-2 flex-wrap flex-lg-nowrap">
                        <div className="d-flex gap-2 align-items-center">
                            <h2 className="fw-medium fs-6 my-2">{currentAsset?.AssetName}</h2>
                        </div>
                    </div>
                    <div className="detail p-3" >
                        <div className="row">
                            <div className="row col-md-8">
                                <div className="col-md-4">
                                    <div >
                                        <label className="label">Default</label>
                                        <div className="col-md-8">
                                                {ShareClassAtrriburtes.IsDefault ? (<input type="checkbox" defaultChecked={isDefault} onChange={() => { setIsDefault(value => !value) }} disabled />) : (<input type="checkbox" defaultChecked={isDefault} onChange={() => { setIsDefault(value => !value) }} />)}
                                        </div>
                                    </div>
                                    <div >
                                        <label className="label">Share Class<span className="mandatory">*</span></label>
                                        <Form.Control type={"text"} defaultValue={shareClass} className="w-75" onKeyUp={(e) => { setShareClass(e.target.value) }} />
                                    </div>
                                    <div>
                                        <label className="label">Minimum Investment
                                        </label>
                                        <div>
                                            <Form.Control type={"number"} defaultValue={minInvestment} className="w-75" onKeyUp={(e) => { setMinInvestment(parseInt(e.target.value)) }} />
                                        </div>
                                    </div>
                                    {/* <div >
                                        <label className="label">Inception Date
                                        </label>
                                        <div>
                                            <DatePicker value={inceptionDate} className="w-75" onChange={(e) => { setInceptionDate(e.value) }} />
                                        </div>
                                    </div> */}
                                    <div >
                                        <label className="label">Effective Date
                                        </label>

                                        <div>
                                            <SBDatePicker value={moment(effectiveDate)} className="w-75" onChange={(e) => { setEffectiveDate(moment(e).format("MM/DD/yyyy")) }} />
                                        </div>
                                    </div>
                                    <div >
                                        <label className="label">Investment Currency
                                        </label>
                                        <div>
                                            <SBAMultiSelect data={ddValuesForShareClass.SubscriptionCurrency} value={investmentCurrency} dataItemKey='Id' textField="Description" className='w-75' onChange={InvestmentCryDDChange} />
                                        </div>

                                    </div>
                                    <div >
                                        <label className="label">Subscription Frequency
                                        </label>
                                        <SBADropDown className='w-75 ' data={ddValuesForShareClass.SubscriptionFrequency} value={subscriptionFrequency} textField="Description" onChange={SubFreDDchange} />
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div >
                                        <label className="label">Tax Reporting
                                        </label>
                                        <div>
                                            <SBADropDown className='w-75 ' data={ddValuesForShareClass.TaxReporting} value={taxReporting} textField="Description" onChange={TaxRepChange} />
                                        </div>

                                    </div>
                                    <div >
                                        <label className="label">Tracking Frequency
                                        </label>
                                        <div>
                                            <SBADropDown className='w-75 ' data={ddValuesForShareClass.TrackingFrequency} value={trackingFrequency} textField="Description" onChange={TrackingFreDDChange} />
                                        </div>

                                    </div>
                                    <div >
                                        <label className="label">Tracked By
                                        </label>
                                        <div>
                                            <SBADropDown className='w-75 ' data={ddValuesForShareClass.TrackedBy} textField="Description" value={trackedBy} onChange={TrackedByDDChange} />
                                        </div>
                                    </div>
                                    <div >
                                        <label className="label">Initial NAV
                                        </label>
                                        <div>
                                            <Form.Control type={"number"} defaultValue={initialNAV} className="w-75" onKeyUp={(e) => { setInitialNAV(parseInt(e.target.value)) }} />
                                        </div>
                                    </div>
                                    <div >
                                            <label className="label">Liquidity Abbreviation
                                        </label>
                                        <div>
                                            <Form.Control type={"text"} defaultValue={liquidityTerms} className="w-75" onKeyUp={(e) => { setLiquidityTerms(e.target.value) }} />
                                        </div>
                                    </div>

                                </div>
                                    <div className="col-md-4 p-2">
                                        <div className="p-3 mb-1">

                                    <div >
                                        
                                                <div className="col-md-8" style={{ marginBottom: "30px" }}>
                                                    
                                                <input type="checkbox" defaultChecked={votingShares} onChange={() => { setVotingShares(value => !value) }} />
                                                        <label className="label ms-2">Voting Shares
                                        </label>
                                                    </div>
                                               
                                    </div>
                                    <div >
                                        
                                                <div className="col-md-8" style={{ marginBottom: "30px" }}>
                                                <input type="checkbox" defaultChecked={newIssues} onChange={() => { setNewIssues(value => !value) }} />
                                                <label className="label ms-2">New Issues
                                        </label>
                                        </div>
                                    </div>
                                    <div >
                                        
                                                <div className="col-md-8" style={{ marginBottom: "30px" }}>
                                                <input type="checkbox" defaultChecked={accredited} onChange={() => { setAccredited(value => !value) }} />
                                                <label className="label ms-2">Accredited
                                        </label>
                                        </div>
                                    </div>
                                    <div >
                                        
                                                <div className="col-md-8" style={{ marginBottom: "30px" }}>
                                                <input type="checkbox" defaultChecked={qualifiedPurchaser} onChange={() => { setQualifiedPurchaser(value => !value) }} />
                                                <label className="label ms-2">Qualified Purchaser
                                        </label>
                                        </div>
                                    </div>
                                    <div >
                                        
                                                <div className="col-md-8" style={{ marginBottom: "30px" }}>
                                                <input type="checkbox" defaultChecked={qualifiedClient} onChange={() => { setQualifiedClient(value => !value) }} />
                                                <label className="label ms-2">Qualified Client
                                        </label>
                                        </div>
                                    </div>
                                    <div >
                                        
                                                <div className="col-md-8" style={{ marginBottom: "30px" }}>
                                                <input type="checkbox" defaultChecked={businessDays} onChange={(e) => { setBusinessDays(value => !value) }} />
                                                <label className="label ms-2">Business Days
                                        </label>
                                        </div>
                                    </div>
                                </div>
                                    </div>
                                </div>
                            <div className="col-md-4">
                                <div className="detail p-3 mb-1">
                                    <div >
                                        <input type="checkbox" disabled={true}/><label className="label ms-2">
                                            Tiered Mgmt Fee
                                        </label>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <label className="label">Management Fee</label>
                                            <Form.Control type={"number"} defaultValue={managementFee} className="w-75" onKeyUp={(e) => { if(parseInt(e.target.value)>100){setManagementFee(100); e.target.value=100}else{setManagementFee(e.target.value)} }} />
                                        </div>
                                        <div className="col-md-6">
                                            <div>
                                                <label className="label"> Fee Frequency</label>
                                                <SBADropDown className='w-75 ' data={ddValuesForShareClass.FeeFrequency} value={mngFeeFrequency} textField="Description" onChange={(e) => { setMngFeeFrequency(e.value) }} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="detail p-3">
                                    <div>
                                        <input type="checkbox" disabled={true}/><label className="label ms-2">
                                            Tiered Performance Fee
                                        </label>
                                    </div>
                                    <div className="row my-2">
                                        <div className="col-md-6">
                                            <label className="label">Performance Fee</label>
                                            <Form.Control type={"number"} defaultValue={performanceFee} max={100} className="w-75" onKeyUp={(e) => { if(parseInt(e.target.value)>100){setPerformanceFee(100); e.target.value=100}else{setPerformanceFee(e.target.value) }}} />
                                        </div>
                                        <div className="col-md-6">
                                            <div>
                                                <label className="label">Payment Frequency</label>
                                                <SBADropDown className='w-75 ' data={ddValuesForShareClass.FeeFrequency} value={paymentFrequency} textField="Description" onChange={(e) => { setPaymentFrequency(e.value) }} />
                                            </div>
                                            <div>
                                                <label className="label">Accural Frequency</label>
                                                <SBADropDown className='w-75 ' data={ddValuesForShareClass.FeeFrequency} value={accuralFrequency} textField="Description" onChange={(e) => { setAccuralFrequency(e.value) }} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row my-2">
                                        <div className="col-md-6">
                                            <div>
                                                <label className="label">Hurdle Rate</label>
                                                <SBADropDown className='w-75 ' data={ddValuesForShareClass.HurdleRate} value={hurdleRate} textField="Description" onChange={(e) => { setHurdleRate(e.value) }} />
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div>
                                                <label className="label">Hurdle Value</label>
                                                <Form.Control type={"number"} defaultValue={hurdleValue} max={100} className="w-75" onKeyUp={(e) => { if(parseInt(e.target.value)>100){setHurdleValue(100); e.target.value=100}else{setHurdleValue(e.target.value)} }} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row my-2">
                                        <div className="col-md-6">
                                            <div>
                                                <input type="checkbox" checked={lossRecoverys} onChange={(e) => { setLossRecoverys(value=>!value) }} /><label className="label ms-2">Loss Recoverys</label>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div>
                                                <label className="label"> Recovery Reset</label>
                                                <SBADropDown className='w-75 ' data={ddValuesForShareClass.LossRecoveryReset} value={recoveryReset} textField="Description" onChange={(e) => { setRecoveryReset(e.value) }} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="my-2 d-flex justify-content-end ">
                            <button className="s-sm-btn mx-2" onClick={navigateToDetails}>Cancel</button>
                            <button className="p-sm-btn mx-2" onClick={saveShareClass} disabled={!isEditable}>Update</button>
                        </div>
                    </div>
                </div>
            </div>}
            <ToastContainer />
        </div>
    )
}
